module.exports = __webpack_public_path__ + "static/img/fimga-import-icon.df3dc4ef.svg";